// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3VV5u","title":"Card_title__jtcIG","year":"Card_year__3eirO","user":"Card_user__VxfxB"};